function isIE() {
	return (window.navigator.userAgent.match(/(MSIE|Trident)/) != null);
}
window.isIE = isIE;

export default isIE